export { default } from './es/icons/AlertTwoTone';